"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Options = exports.C = exports.DeepstreamClient = void 0;
var deepstream_client_1 = require("./deepstream-client");
Object.defineProperty(exports, "DeepstreamClient", { enumerable: true, get: function () { return deepstream_client_1.DeepstreamClient; } });
Object.defineProperty(exports, "C", { enumerable: true, get: function () { return deepstream_client_1.C; } });
Object.defineProperty(exports, "Options", { enumerable: true, get: function () { return deepstream_client_1.DefaultOptions; } });
